import React, { Component } from "react";
import { connect } from "react-redux";
import { customerActions } from "redux/actions/customer-action";
import Select from "react-select";
import { helperFunctions as HF } from "../../../helper/helperFunctions";

class CustomerDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.props.stateProp,
            selected_value: "",
            selected_model: null
        };
    }

    componentDidMount() {
        this.setState({ selected_value: this.props.selectedCustomer, selected_model: this.props.modelProp });
        this.props.getCustomerDataCall(1, "", "", 10);
    }

    getOptions(data) {
        if (data === undefined) {
            return [];
        }
        return data.map(({ id, title }) => ({
            value: id,
            label: HF.Capitalize(title)
        }));
    }

    handleChange = e => {
        let value = undefined;
        if (e == null) {
            value = undefined;
        } else {
            value = e.value;
        }
        this.setState({
            selected_value: value
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.state.selected_value !== prevState.selected_value) {
            this.props.onReturnFullState({
                model_id: this.state.selected_value
            });
        }
    }

    render() {
        const customers = this.getOptions(this.props.customersDropdownData);
        const { selected_value, selected_model } = this.state;

        return (
            <React.Fragment>
                <div
                    className="col-md-4"
                    style={{ paddingTop: "12px" }}
                >
                    Currently Editing:
                </div>
                <div className="col-md-8 no-padding">
                    <Select
                        value={HF.returnLabelWithValue(selected_value, customers)}
                        onChange={this.handleChange}
                        options={customers.sort((a, b) => a.label.localeCompare(b.label))}
                        isSearchable={true}
                        isMulti={false}
                        placeholder={"Select Customer"}
                        isClearable={true}
                        isDisabled={selected_model === 'App\\Customer'}
                    />
                </div>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCustomerDataCall: (page, filter, sort, pageSize) => {
            dispatch(
                customerActions.getCustomersDropdown(
                    page,
                    filter,
                    sort,
                    pageSize
                )
            );
        }
    };
};

function mapStateToProps(state) {
    const { customersData } = state.customerReducer;

    return {
        customersDropdownData: customersData
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDropdown);



// WEBPACK FOOTER //
// ./src/components/Admin/Customers/CustomerDropdown.jsx